import { useQuery } from "@tanstack/react-query";
import { getCompetitionStats } from "../openapi/api-client";

export const useCompetitionStats = (competitionId?: string) => {
  return useQuery({
    queryKey: ["competitionStats", { competitionId }],
    queryFn: async () => {
      if (!competitionId) {
        throw new Error("competitionId is required");
      }

      const response = await getCompetitionStats({ competitionId });
      return response.data;
    },
    enabled: !!competitionId,
  });
};
